import type { DbChatType } from "@/types/db";

/**
 * Where an existing chat reopens.
 *
 * Each chat surface owns its own route, and `chats.type` is the only record of
 * which one created a chat. Routing a code chat back to "/" would drop it into
 * the home chat: no sandbox files panel, attachments into the widget store
 * instead of the container, and `mode: "general"` on every request.
 *
 * Callers pass the row's `type`; anything unrecognised (an older row, a value
 * a newer client wrote) falls back to the home chat rather than a dead route.
 */
export function chatHref(
  chatId: string,
  type: DbChatType | null | undefined
): string {
  return type === "code" ? `/code?chat=${chatId}` : `/?chat=${chatId}`;
}

export function projectNewChatHref(projectId: string): string {
  const params = new URLSearchParams({ project: projectId, newChat: "1" });
  return `/?${params.toString()}`;
}

export function projectLiveChatHref({
  projectId,
  model,
  webSearch,
  agentId,
}: {
  projectId: string;
  model: string;
  webSearch: boolean;
  agentId: string | null;
}): string {
  const params = new URLSearchParams({
    project: projectId,
    live: "1",
    ws: webSearch ? "1" : "0",
    ce: "1",
    model,
  });
  if (agentId) params.set("agent", agentId);
  return `/?${params.toString()}`;
}
